import { render, staticRenderFns } from "./EntityIndicators.vue?vue&type=template&id=63ab25c4&scoped=true&"
import script from "./EntityIndicators.vue?vue&type=script&lang=js&"
export * from "./EntityIndicators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ab25c4",
  null
  
)

export default component.exports